module.exports = __webpack_public_path__ + "static/img/naturalCircle8.6e014ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle8.svg
// module id = /FQI
// module chunks = 1